import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import './Auth.css';
import '../../pages/Pages.css';
import artfooter from '../home/image/artfooter.png';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const recaptcha = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError(t('please_enter_email'));
      return;
    }
    
    // Verify reCAPTCHA
    const captchaValue = recaptcha.current.getValue();
    if (!captchaValue) {
      setError(t('recaptcha_not_ready'));
      return;
    }
    
    try {
      setLoading(true);
      setError('');
      
      // Send request to the API with recaptcha token
      await axios.post('users/forgot-password', { 
        email,
        recaptchaToken: captchaValue 
      });
      
      // Show success message
      setSuccessMessage(t('password_reset_email_sent'));
      
      // Clear the email field
      setEmail('');
      
    } catch (err) {
      console.error('Forgot password error:', err);
      if (err.response?.data?.error?.code === 'RECAPTCHA_FAILED') {
        setError(t('recaptcha_verification_failed'));
      } else {
        setError(err.response?.data?.error || t('general_error'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card forgot-password-card">
        <div className="logo-container logo-ellipse">
          <img src={artfooter} alt={t('studio_name')} className="footer-logo-img" />
        </div>
        
        <p className="welcome-text">{t('studio_name')}</p>
        
        <h2>{t('forgot_password')}</h2>
        
        {successMessage ? (
          <div className="success-message">
            <p>{successMessage}</p>
            <p className="auth-link">
              <Link to="/login">{t('back_to_login')}</Link>
            </p>
          </div>
        ) : (
          <>
            <p className="auth-description">
              {t('forgot_password_description')}
            </p>
            
            {error && (
              <div className="error-message">
                {error}
              </div>
            )}
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">{t('email')}</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('enter_your_email')}
                  required
                  disabled={loading}
                />
              </div>
              
              <div className="form-group recaptcha-container">
                <ReCAPTCHA
                  ref={recaptcha}
                  sitekey="6LdfTT8rAAAAAM_TkD9dKutCyy3LJ4KHyINaRWtI"
                />
              </div>
              
              <button 
                type="submit" 
                className="auth-button"
                disabled={loading}
              >
                {loading ? t('sending') : t('send_reset_link')}
              </button>
            </form>
            
            <p className="auth-link">
              {t('remembered_password')} <Link to="/login">{t('back_to_login')}</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword; 